import React from "react";
import { Typography } from "antd";
import heroImg from "../../assets/landing-page/hero.png";
import dealVoiceLogo from "../../assets/logo/dealVoice.png";

const { Text } = Typography;

function GrowWithSection() {
  return (
    <section className="grow-with-section" id="grow-with-dealvoice">
      <div className="grow-container">
        {/* Left: Grow With DealVoice Header & Doodle Arrow */}
        <div className="grow-left-block">
          <div className="grow-title">
            <div>Grow</div>
            <div className="grow-title-with-row">
              <span>with</span>
              <img
                src={dealVoiceLogo}
                alt="DealVoice"
                className="grow-title-logo"
              />
            </div>
          </div>

          {/* Hand-Drawn Spiral Loop Doodle Arrow */}
          <div className="grow-doodle-arrow-wrap">
            <svg
              width="110"
              height="118"
              viewBox="0 0 110 118"
              fill="none"
              className="grow-doodle-arrow"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M 32 10 C 18 20, 12 40, 18 58 C 24 76, 48 78, 56 56 C 64 34, 42 26, 32 48 C 22 70, 24 92, 48 102 C 64 108, 82 106, 98 104"
                stroke="#64748b"
                strokeWidth="3.2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              />
              <path
                d="M 86 94 L 100 104 L 86 114"
                stroke="#64748b"
                strokeWidth="3.2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              />
            </svg>
          </div>
        </div>

        {/* Right: 3 Ascending Arches */}
        <div className="grow-arches-wrap">
          {/* Arch 1: 27% Increased Productivity (Purple) */}
          <div className="grow-arch arch-purple">
            <div className="arch-text-content">
              <div className="arch-metric-num">27%</div>
              <Text strong className="arch-metric-title">
                Increased productivity
              </Text>
              <Text className="arch-metric-desc">Do more in less time</Text>
            </div>

            {/* Bottom Graphic: Upward Growth Arrow */}
            <div className="arch-bottom-graphic">
              <svg viewBox="0 0 160 90" fill="none" className="arch-svg-growth">
                <path
                  d="M20 75 L65 45 L95 58 L142 18"
                  stroke="#7c3aed"
                  strokeWidth="14"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M115 18 L142 18 L142 45"
                  stroke="#7c3aed"
                  strokeWidth="14"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>

          {/* Arch 2: 50% Faster Implementation (Cyan) */}
          <div className="grow-arch arch-cyan">
            <div className="arch-text-content">
              <div className="arch-metric-num">50%</div>
              <Text strong className="arch-metric-title">
                Faster implementation
              </Text>
              <Text className="arch-metric-desc">Get started in no time</Text>
            </div>

            {/* Bottom Graphic: Gear / Setting Shape */}
            <div className="arch-bottom-graphic">
              <svg viewBox="0 0 160 90" fill="none" className="arch-svg-gear">
                <circle cx="80" cy="85" r="46" fill="#0284c7" fillOpacity="0.3" />
                <path
                  d="M72 32h16v14h-16z M28 77v-16h14v16z M118 77v-16h14v16z M40 44l12-12 10 10-12 12z M98 102l12-12 10 10-12 12z M40 110l12 12 10-10-12-12z M98 52l12 12 10-10-12-12z"
                  fill="#0284c7"
                  fillOpacity="0.4"
                />
              </svg>
            </div>
          </div>

          {/* Arch 3: 71% Saved on Licensing Fees (Peach) */}
          <div className="grow-arch arch-peach">
            <div className="arch-text-content">
              <div className="arch-metric-num">71%</div>
              <Text strong className="arch-metric-title">
                Saved on licensing fees
              </Text>
              <Text className="arch-metric-desc">Big savings for a lifetime</Text>
            </div>

            {/* Bottom Graphic: Hero image cutout */}
            <div className="arch-hero-wrap">
              <img
                src={heroImg}
                alt="Grow with DealVoice"
                className="arch-hero-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default GrowWithSection;
